import { useEffect, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  borderRadius: 2,
  minWidth: 300,
};

const ModalEditarCandidatos = ({
  open,
  onClose,
  candidato,
  showToast,
  provinciasList,
  localidadesList,
}) => {
  //const UrlApi = "http://localhost:27021/api"; //usoLocal
  const UrlApi = "https://empleosback.netizar.com/api"; //Ruta para produccion

  const [localidades, setLocalidades] = useState(localidadesList || []);
  const [provinciaSeleccionada, setProvinciaSeleccionada] = useState(
    candidato.id_provincia || null
  );

  const [cambioLaProvincia, setCambioLaProvincia] = useState(false);
  const [localidadSeleccionada, setLocalidadSeleccionada] = useState(
    candidato.id_localidad || null
  );

  useEffect(() => {
    if (!open) return;
    fetch(`${UrlApi}/localidades/${provinciaSeleccionada}`)
      .then((res) => res.json())
      .then((data) => setLocalidades(data.data));
  }, [open === true, cambioLaProvincia]);

  const handleProvinciaChange = (e) => {
    const nuevaProvincia = e.target.value;
    setProvinciaSeleccionada(nuevaProvincia);
    setLocalidades("");
    setLocalidadSeleccionada("");
    setCambioLaProvincia(!cambioLaProvincia);
  };

  const handleLocalidadChange = (e) => {
    const nuevaLocalidad = e.target.value;
    setLocalidadSeleccionada(nuevaLocalidad);
  };

  const handleGuardar = async (e) => {
    e.preventDefault();
    const provincia = provinciasList.find(
      (p) => p.id === provinciaSeleccionada
    );
    const localidad = localidades.find((l) => l.id === localidadSeleccionada);
    const idCandidato = candidato.id;
    console.log("Candidato id", candidato.id);
    console.log("Provincia:", provincia);
    console.log("Localidad:", localidad);

    const response = await fetch(`${UrlApi}/cambiarDomicilio`, {
      headers: { "Content-Type": "application/json" },
      method: "PUT",
      body: JSON.stringify({
        idCandidato: idCandidato,
        idLocalidad: localidadSeleccionada,
        idProvincia: provinciaSeleccionada,
      }),
    });

    if (!response.ok)
      showToast(
        "Ocurrio un error durante la actualizacion del candidato",
        "error"
      );
    else showToast("El candidadato se actualizo correctamente");

    onClose();
  };

  return (
    <>
      <Modal open={open} onClose={() => onClose()}>
        <Box sx={style}>
          <Typography variant="h6" mb={2}>
            Editar provincia y localidad
          </Typography>

          <FormControl fullWidth sx={{ mb: 2 }}>
            <InputLabel>Provincia</InputLabel>
            <Select
              value={provinciaSeleccionada}
              onChange={handleProvinciaChange}
              label="Provincia"
            >
              {(provinciasList || []).map((provincia) => (
                <MenuItem value={provincia.id} key={provincia.id}>
                  {provincia.provincia}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth sx={{ mb: 3 }} disabled={!provinciasList}>
            <InputLabel>Localidad</InputLabel>
            <Select
              disabled={!provinciaSeleccionada}
              value={localidadSeleccionada}
              onChange={handleLocalidadChange}
              label="Localidad"
            >
              {(localidades || []).map((localidad) => (
                <MenuItem value={localidad.id} key={localidad.id}>
                  {localidad.localidad}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Button
            onClick={handleGuardar}
            variant="contained"
            disabled={!provinciasList || !localidades}
          >
            Guardar
          </Button>
        </Box>
      </Modal>
    </>
  );
};

export default ModalEditarCandidatos;
